import { Model } from '@/models/Model';

export class Tag extends Model
{
  protected $name: string = 'Tag';
  protected $endpoint: string = '/tags';
  protected $fillable: string[] = ['name'];

  public name?: string;
  public id?: string;
  public uuid?: string;

  protected static instance?: Tag;
  public static getInstance(instance: Tag) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
